<div class="center-msg center-msg-v2">
    <div class="item success">
        <div class="img"><img src="assets/image/medalha_full.png" alt=""></div>
        <div class="text">
            <div class="t-5"><strong>Parabéns! Suas informações estão em análise!</strong></div>
        </div>
        <div class="link link-v2">
            <div class="row d-flex justify-content-center">
                <div class="col-md-4"><button (click)="goHome()" type="button" class="btn-xp-m2 btn-blue-30 btn-block">Ir para Home</button></div>
            </div>
        </div>
    </div>
</div>
